module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8LbzFj/media/FC-9798889100553.jpg?1743119314665",
      "alt": "This image is the cover for the book Guardian Guerrillas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guardian Guerrillas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is the fascinating story of Frank James, Jesse James older brother, as a bushwhacker in Quantrill’s Partisan Rangers during the Civil War. The actions of this brash, Shakespeare quoting young man represents the best and worst of guerrilla warfare in those turbulent and violent times.")]), _c('p', [_c('br')]), _c('p', [_vm._v("After fighting as a Confederate soldier at Wilson’s Creek, captured and paroled, he returned home as a cocky nineteen-year-old barely staying out of jail. He joins Quantrill’s bushwhackers with escapades that are full of daring and bravery, sometimes cruelty, but also with humour.")]), _c('p', [_c('br')]), _c('p', [_vm._v("We follow him through the many skirmishes and battles including the raids on Lawrence Kansas and Centralia Missouri and the critical events that precipitated them, the women’s prison collapse where several bushwhacker relatives were killed or injured and the infamous “General Order Number 11” that forcibly drove out all residents of an area over 2,200 square miles, twice the size of Rhode Island.")]), _c('p', [_c('br')]), _c('p', [_vm._v("The characters in this work include soldiers, generals, politicians, crooks, thieves, farmers, bankers, lovers, wives, and sisters that suffered or caused suffering in this oft untold American history and their post bellum lives that were fraught with danger, excitement, success for some, failure for many, with ironic, karmic twists.")]), _c('p', [_c('br')]), _c('p', [_vm._v("What drove these young men to become Jayhawkers and Bushwhackers? Were they blood thirsty cutthroats or "), _c('em', [_vm._v("Guardian Guerrillas?")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom Drennen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Tom Drennen is a long-time student of the American Civil War, particularly the guerrilla warfare in his home state of Missouri. After retiring from a successful career as an engineer at Sikorsky Aircraft, he turned his attention to researching what forces drove young men in the 1860s to become Jayhawkers and Bushwhackers. He is a founding member of the Shoreline Civil War Discussion Group in Connecticut. Tom is also a life-long St. Louis Cardinals fan. Go Redbirds!")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0